// extracted by mini-css-extract-plugin
module.exports = {"root":"_3G2fz","title":"CvXzd","subtitle":"_93INk"};